import React from 'react'
import { VideoCard } from './VideoCard'

export const VideoGrid = ({ videos, viewMode = 'grid', loading = false }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {[...Array(8)].map((_, index) => (
          <div key={index} className="animate-pulse">
            <div className="bg-gray-800 aspect-video rounded-lg mb-2"></div>
            <div className="h-4 bg-gray-800 rounded mb-1"></div>
            <div className="h-3 bg-gray-800 rounded w-3/4"></div>
          </div>
        ))}
      </div>
    )
  }

  if (viewMode === 'list') {
    return (
      <div className="space-y-4">
        {videos.map((video) => (
          <VideoCard 
            key={video.id} 
            video={video} 
            layout="list"
          />
        ))}
      </div>
    )
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
      {videos.map((video) => (
        <VideoCard 
          key={video.id} 
          video={video} 
          layout="grid"
        />
      ))}
    </div>
  )
}